import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DisabledRequestDrawButton } from './components/DisabledRequestDrawButton';
import { EnabledRequestDrawButton } from './components/EnabledRequestDrawButton';
import { DrawApi } from '@apply/api';

interface RequestDrawButtonProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}
export const RequestDrawButton = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }: RequestDrawButtonProps) => {
    const addDraw = dashboardDrawBudget.canAddDraw;
    const disabledDraw = !dashboardDrawBudget.drawBudgetId;

    if (addDraw) return <EnabledRequestDrawButton handleClick={() => set_modalDashboarDrawBudget(dashboardDrawBudget)} />;

    if (disabledDraw || !addDraw) {
        return <DisabledRequestDrawButton dashboardDrawBudget={dashboardDrawBudget} />;
    }
};
